import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  // You can customize your theme here
  palette: {
    primary: {
      main: '#1976d2',
    },
    secondary: {
      main: '#dc004e',
    },
  },
});

export default theme;